import { Button, Drawer, Form, Input, Select, Space } from "antd";
import { useContext, useEffect, useState } from "react";
import { IBaseDrawerModel } from "../../../Types";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import OrganisationsService, {
  IOrganiseData,
  ISubUnitData,
  ISubUnitRequestModel,
} from "../../Services/Organisations/OrganisationsService";
import { IApiResponse } from "../../../Utilities/ApiUtility.axios";
import { IIdNameModel } from "../../Services/ItemsService";

const AddSubUnitModel = ({
  isModalOpen,
  setIsModalOpen,
  id,
  setTrigger,
}: IBaseDrawerModel) => {
  const [form] = Form.useForm<ISubUnitRequestModel>();
  const { currentClient } = useClient();
  const [loading, setLoading] = useState<boolean>(false);
  const { openNotification } = useContext(notificationContext);
  const [orgList, setOrgList] = useState<IOrganiseData[]>([]);

  const saveData = async (formData: ISubUnitRequestModel) => {
    setLoading(true);
    await OrganisationsService.postSubUnit(currentClient?.id!, formData, id!)
      .then((val: IApiResponse<IIdNameModel>) => {
        openNotification(
          "success",
          `${val?.result?.name} sub unit ${
            id ? "updated" : "added"
          } successfully`
        );
        setIsModalOpen({
          open: false,
          id: "",
        });
        setLoading(false);
        setTrigger && setTrigger((prev) => !prev);
      })
      .catch((er) => {
        openNotification("error", er.message);
        setLoading(false);
      });
  };

  const submitForm = (val: ISubUnitRequestModel) => {
    saveData(val);
  };

  const getData = async () => {
    setLoading(true);
    await OrganisationsService.getSubUnit(currentClient?.id!, id!)
      .then((val: ISubUnitData | null) => {
        let formValues = {
          subUnitName: val?.subUnitName,
          orgId: val?.orgId,
        };
        form.setFieldsValue(formValues);
        setLoading(false);
      })
      .catch((er) => {
        openNotification("error", er.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (id) getData();
  }, [id]);

  const getOrgList = async () => {
    setLoading(true);
    await OrganisationsService.getOrganisationsList(currentClient?.id!)
      .then((val: IOrganiseData[] | null) => {
        setOrgList(
          val?.map((org: IOrganiseData) => ({
            id: org.id,
            orgName: org.orgName,
          })) || []
        );
        setLoading(false);
      })
      .catch((er) => {
        openNotification("error", er.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    getOrgList();
  }, [currentClient?.id]);

  return (
    <Drawer
      open={isModalOpen}
      onClose={() =>
        setIsModalOpen({
          open: false,
          id: "",
        })
      }
      title={`${id ? "Update" : "Save"} sub unit`}
      width={"30vw"}
      extra={
        <Space>
          <Button
            disabled={loading}
            onClick={() => {
              form.resetFields();
              setIsModalOpen({
                open: false,
                id: "",
              });
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            loading={loading}
            type="primary"
            onClick={() => {
              form.validateFields().then(submitForm);
            }}
          >
            {`${id ? "Update" : "Save"}`}
          </Button>
        </Space>
      }
    >
      <Form name="subunit" form={form} disabled={loading} layout="vertical">
        <Form.Item
          name="subUnitName"
          label="Sub Unit's Name"
          rules={[
            { required: true },
            {
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.,]{2,49}$/,
              message: "Value's length must be between 3 and 50",
            },
          ]}
        >
          <Input
            type="text"
            maxLength={50}
            minLength={3}
            placeholder="Enter name here..."
          ></Input>
        </Form.Item>
        <Form.Item
          name="orgId"
          label="Organisation"
          rules={[{ required: true, message: "Please select organisation" }]}
        >
          <Select
            placeholder="Select organisation"
            options={orgList.map((org: IOrganiseData) => ({
              label: org.orgName,
              value: org.id,
              key: org.id,
              title: "",
            }))}
          ></Select>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddSubUnitModel;
